module.exports = __webpack_public_path__ + "static/media/redirect.189e39c8.svg";